import { constants } from "../../../constants";

export default class GameSpinEnd {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    GREENTUBE_handler() {
        // GT triggers this call also on start/load and it looks a bit stupid ... so we suppress is ...
        if (this.gb.isSpinning !== true) return;

        this.gb.emitters.emit.web.gameSpinEnd();
        this.gb.isSpinning = false;
    }

    _PRAGMATIC_PLAY_handler() {
        /*
        from docs:
            Event Name                      Description
            "spinEnded"                     Reels stopped
            "gameRoundEnded"                Game  round  is  finished  (it  comes  before  resultShown event)   <- this one gets voided!
        */

        this.gb.emitters.emit.web.gameSpinEnd();
        this.gb.isSpinning = false;
    }

    SH_handler(payload) {
        if (payload && payload.value === 'stop') {
            this.gb.emitters.emit.web.gameSpinEnd();
            this.gb.isSpinning = false;
        }
    }

    EVOLUTION_handler() {
        this.gb.isSpinning = false;
        this.gb.emitters.emit.web.gameSpinEnd();
        
        if (gb.walletProtocol && gb.walletProtocol !== constants.EXCITE) {
            this.gb.emitters.emit.web.keepAlive();
        }
    }

    SPINOMENAL_handler(data) {
        if (data && data.data) {
            this.gb.emitters.emit.web.gameSpinEnd();
            if (data.data.win) {
                this.gb.emitters.emit.web.wonAmountChange({payload: { winAmount: data.data.win*100 }});
            }
            if (data.data.balanceAfter) {
                this.gb.emitters.emit.web.balanceChange(data.data.balanceAfter*100);
            }
        }
    }

    _default() {
        this.gb.isSpinning = false;
        this.gb.emitters.emit.web.gameSpinEnd();

        this.gb.emitters.emit.web.keepAlive();

        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable && !this.gb.api.modules.superWheel.superwheelActive) {
            this.gb.api.modules.superWheel.notifyInactiveSpinCompleted();
            this.gb.api.modules.superWheel.showTeaser(false);
            // }
        } else if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable && this.gb.api.modules.superWheel.superwheelActive) {
            if(this.gb.wonAmount && this.gb.wonAmount === 0) {
                delete this.gb.wonAmount;
                this.gb.api.modules.superWheel.showTeaser(false);
            }
        }
    }

    _void() {
        // do nothing
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EVOLUTION:
                event["GAME_STATE_BETS_OPENED"] = this.EVOLUTION_handler;
                break;
            case constants.PRAGMATIC_PLAY:
                event["gameRoundEnded"] = this._void;
                event["spinEnded"] = this._PRAGMATIC_PLAY_handler;
                break;
            case constants.AMATIC:
                event["roundEnded"] = this._default;
                break;
            case constants.F1X2:
                event["play-end"] = this._default;
                break;
            case constants.SLINGO:
                event["gameNotBusy"] = this._default;
                break;
            case constants.GREENTUBE:
                event["BeforeSpin"] = this.GREENTUBE_handler;
                break;
            case constants.QS:
            case constants.RELAX:
                event["gprg_GameRoundEnd"] = this._default;
                break;
            case constants.IGT:
                event["rgs2cWagerComplete"] = this._default;
                event["rgs2custWagerAborted"] = this._default;
                break;
            case constants.PNG:
                event["roundEnded"] = this._default;
                break;
            case constants.NETE:
                event["spinEnded"] = this._default;
                break;
            case constants.MGS:
                event["gameNotBusy"] = this._default;
                break;
            case constants.NEXTGEN:
            case constants.NYXNEXTGEN:
                event["gameAnimationComplete"] = this._default;
                break;
            case constants.THUNDER:
                event["roundended"] = this._default;
                break;
            case constants.BP:
                event["gameNotBusy"] = this._default;
                break;
            case constants.EDICT:
                event["gameRoundEnded"] = this._default;
                break;
            case constants.EZUGI:
                event["round.place_your_bets"] = this._default;
                break;
            case constants.GSPOKER:
            //case constants.GSBINGO:
                event["gameNotBusy"] = this._default;
                break;
            case constants.SH:
                event["autoSpin"] = this.SH_handler;
                break;
            case constants.BGS:
                event["gameNotBusy"] = this._default;
                break;
            case constants.RGU:
                event["gameNotBusy"] = this._default;
                break;
            case constants.RAW:
                event["gameNotBusy"] = this._default;
                break;
            case constants.HB:
                event["gameNotBusy"] = this._default;
                break;
            case constants.DGC:
                event["gel.spin.end"] = this._default;
                break;
            case constants.RRG:
                event["ROUND_END"] = this._default;
                break;
            case constants.WD:
                event["WGEAPI.spinEnded"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["ROUND_END"] = this._default;
                break;
            case constants.SPRIBE:
                event["ifc.end.round"] = this._default;
                break;
            case constants.HKS:
                event["onRoundEnded"] = this._default;
                    break;
            case constants.SYN:
                event["g2p.spinEnded"] = this._default;
                break;
            case constants.KAJ:
                event["game.spin.ended"] = this._default;
                break;
            case constants.ISOFT:
                event["ROUND_ENDED"] = this._default;
                break;
            case constants.RST:
                event["gameNotBusy"] = this._default;
                break;
            case constants.PT:
                event["ucip.gameround.g2wGameRoundEndNotification"] = this._default;
                break;
            case constants.NLC:
                event["idle"] = this._default;
                break;
            case constants.YGG:
                event["spin/end"] = this._default;
                break;
            case constants.HBN:
                // event["spinEnded"] = this._default;
                event["gameNotBusy"] = this._default;
                break;
            case constants.PLS:
                event["mainspin_END"] = this._default;
                break;
            case constants.SPIN:
                event["round_complete"] = this._default;
                break;
            case constants.ENDOR:
                event["endGame"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["betFinished"] = this.SPINOMENAL_handler;
                break;
            default:
                event["gameSpinEnd"] = this._default;
        }

        return event;
    }
}
